import React from 'react';
import pick from 'lodash/pick';

import Form from '../common/Form';
import { getLocationTypes } from '../../helpers/selectOptions';

const getFields = () => [
  {
    name: 'title',
    label: 'Title',
    type: 'text',
    required: true
  },
  {
    name: 'text',
    label: 'Text',
    type: 'textarea',
    rows: 4,
    required: true
  },
  {
    name: 'location_type',
    label: 'Location Type',
    type: 'options',
    options: getLocationTypes(),
    required: true,
    parser: (value, formData) => ({
      location_type: value,
      location_id: null,
    }),
  },
  {
    name: 'location_id',
    label: 'Location',
    type: 'selectLocation',
    required: true,
    validate: () => true,
    prerequisites: formData => formData?.location_type === 'PARTNER',
  },
];

const getDefaultValues = ({isEditing, doc}) => {
  console.log('DOC', doc);
  return (
    isEditing 
    ? pick(doc, 'title', 'text', 'location_type', 'location_id')
    : {
      title: '',
      text: '',
      location_type: null,
      location_id: null,
    }
  );
};

const SessionInstructionForm = ({ 
  doc, 
  isEditing,
  onSubmit 
}) => {
  return (
    <Form
      fields={getFields(doc)}
      isEditing={isEditing}
      defaultValues={getDefaultValues({isEditing, doc})}
      onSubmit={onSubmit}
    />
  );
};

export default SessionInstructionForm;